export default __webpack_public_path__ + "static/media/Gal-bearileo-expanded.28aa9ad0.png";